import PropTypes from 'prop-types';

const shape = PropTypes.arrayOf(PropTypes.string);

export default PropTypes.shape({
  flights: shape,
  hotels: shape,
  cars: shape,
});
